import { render, staticRenderFns } from "./DeleteProductButton.vue?vue&type=template&id=7a0e358c"
import script from "./DeleteProductButton.vue?vue&type=script&lang=js"
export * from "./DeleteProductButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports